<template>
    <v-snackbar v-model="snackbar" :timeout="5000" v-if="error">
        {{ error.message }}
        <v-btn color="indigo" text @click="snackbar = false">
            Close
        </v-btn>
    </v-snackbar>
</template>
<script>
export default {
    data: () => ({
        snackbar: false
    }),

    watch: {
        'error' (val) {
            if(val) this.snackbar = true
        }
    },

    computed: {
        error() {
            return this.$store.getters.getError
        }
    }
}
</script>